export default __webpack_public_path__ + "static/media/pendingIcon.3d9dff75.svg";